import React from 'react';
import {
  FormHelperText,
  Autocomplete,
  TextField,
  Tooltip,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useUser } from '@/providers';

export default function PrivateServicesField({
  value,
  setValue,
  setChanged,
  edit,
}) {
  const user = useUser();
  const projectServices = useSelector((state) => state.projectServices) || [];

  const isDisabled = edit || !user.cloudbender_enabled;

  const options = projectServices.map((service) => ({
    id: service.service_id || service.id,
    label: service.name,
  }));

  const selectedValues = value
    ? value
        .map((serviceId) => {
          const service = projectServices.find(
            (s) => (s.service_id || s.id) === serviceId,
          );
          return service
            ? {
                id: service.service_id || service.id,
                label: service.name,
              }
            : null;
        })
        .filter((v) => v !== null)
    : [];

  const handleChange = (event, newValue) => {
    const serviceIds = newValue.map((option) => option.id);
    if (JSON.stringify(serviceIds) !== JSON.stringify(value || [])) {
      setChanged();
    }
    setValue(serviceIds);
  };

  const field = (
    <>
      <Autocomplete
        disablePortal
        multiple
        id='private-services'
        options={options}
        value={selectedValues}
        onChange={handleChange}
        disabled={isDisabled}
        isOptionEqualToValue={(option, val) => option.id === val.id}
        getOptionLabel={(option) => option.label || ''}
        renderInput={(params) => (
          <TextField {...params} label='Private Services' />
        )}
      />
      <FormHelperText id='private-services-helper-text'>
        Select private services to attach to this job
      </FormHelperText>
    </>
  );

  if (isDisabled && !user.cloudbender_enabled) {
    return (
      <Tooltip title='Purchase a CloudBender subscription to enable this feature'>
        <span>{field}</span>
      </Tooltip>
    );
  }

  return field;
}
